var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c(
          "q-card",
          { staticStyle: { width: "100%" } },
          [
            _c("q-card-section", [
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.data.noticeContents) },
              }),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }